module.exports = __webpack_public_path__ + "static/media/ils_login.6e40afa2.svg";